import dayjs from 'dayjs';
import { RESULT_BIG, RESULT_SAME, RESULT_SMALL } from '@/types';
import { DEFAULT_FORMAT } from './common/name-space';

export const now = (aData: string = '', aFormat: string = DEFAULT_FORMAT) => {
  return aData ? dayjs(aData).format(aFormat) : dayjs().format(aFormat);
};

export const addTime = (aData: string = '', aAdd: number = 1) => {
  const currentDate = aData ? dayjs(aData) : dayjs();
  // 9시간을 더하기 (한국 시간으로 변경)
  const newDate = currentDate.add(aAdd, 'hour');
};

export const compareDate = (aDay1: string, aDay2: string): number => {
  const d1 = dayjs(aDay1);
  const d2 = dayjs(aDay2);
  if (d1.isAfter(d2)) {
    // console.log('date1은 date2보다 이후입니다.');
    return RESULT_BIG;
  } else if (d1.isBefore(d2)) {
    // console.log('date1은 date2보다 이전입니다.');
    return RESULT_SMALL;
  } else {
    // console.log('date1과 date2는 같은 날짜입니다.');
    return RESULT_SAME;
  }
};

// db에서 값을 읽어 올 때 -9 해야 제대로 된 값을 가져온다. 로컬만 해당됨
export const nowSubtractToISOString = (aData: string | Date = '', aFormat: string = DEFAULT_FORMAT) => {
  const currentDate = aData ? dayjs(aData) : dayjs();
  // 9시간을 더하기 (한국 시간으로 변경)
  const newDate = currentDate.subtract(9, 'hour');

  return dayjs(newDate).format(aFormat);
};

// 입력한 형식이 맞는지 체크
export const isValid = (aData: string, format: string = DEFAULT_FORMAT): boolean => {
  return dayjs(aData, format, true).isValid();
};
